import { render, staticRenderFns } from "./PatternLab.vue?vue&type=template&id=47e436fc&scoped=true&"
import script from "./PatternLab.vue?vue&type=script&lang=js&"
export * from "./PatternLab.vue?vue&type=script&lang=js&"
import style0 from "./PatternLab.vue?vue&type=style&index=0&id=47e436fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e436fc",
  null
  
)

export default component.exports